
import { WarningIcon } from '@inspera/component-library';
import * as React from 'react';
import { tl } from 'common/services/i18nService';
import * as styles from './ValidationWarning.scss';
import urlContextParametersService from '../../services/urlContextParametersService';

interface ValidationIssueProps {
    partyId: number;
    questionId: number;
}

const ValidationWarning: React.FC<ValidationIssueProps> = ({ partyId, questionId }) => {
    const navigateToCandidateQuestionInMarking = () => {
        urlContextParametersService.setWorkspaceId('evaluate_marking');
        setTimeout(() => {
            urlContextParametersService.setPartyId(partyId);
            urlContextParametersService.setQuestionId(questionId);
        }, 300);
    };

    return (
        <div className={styles.messageContainer}>
            <div className={styles.message}>
                <WarningIcon
                    style={{ color: '#f2c600', marginRight: '0.5rem' }}
                    fontSize="large"
                />
                <span className={styles.messageTitle}>
                    {tl('grading.validationWarning.title')}
                </span>
            </div>
            <span style={{
                marginTop: '0.5rem', marginLeft: '2rem', fontSize: '16px',
            }}
            >
                {tl('grading.validationWarning.message')}
            </span>
            <div>
                <button
                    type="button"
                    onClick={navigateToCandidateQuestionInMarking}
                    className={styles.reviewBtn}
                >
                    {tl('grading.validationWarning.reviewButton')}
                </button>
            </div>
        </div>
    );
};
export default ValidationWarning;
